import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { ContextMenuService } from '@core/services/context-menu.service';
import { ITriviaRain } from '../interfaces/trivia.interface';
import { User } from '@core/interfaces/user.interface';
import { TriviaService } from '../trivia.service';
import {
  CountdownComponent,
  CountdownEvent,
  CountdownStatus,
} from 'ngx-countdown';
import { CostComponent } from '@core/components/cost/cost.component';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { NgpTooltip, NgpTooltipTrigger } from 'ng-primitives/tooltip';
import { SvgIconComponent } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';
import { sleep } from '@core/utils/sleep.util';

@Component({
  selector: 'app-trivia-rain-widget',
  imports: [
    CountdownComponent,
    CostComponent,
    PlayerRowComponent,
    NgpTooltip,
    NgpTooltipTrigger,
    SvgIconComponent,
  ],
  templateUrl: './trivia-rain-widget.component.html',
  styleUrl: './trivia-rain-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TriviaRainWidgetComponent {
  public contextMenuService = inject(ContextMenuService);
  private triviaService = inject(TriviaService);
  private toastrService = inject(ToastrService);

  triviaRain = input.required<ITriviaRain>();
  options = computed(() =>
    this.triviaRain().options.sort(() => Math.random() - 0.5)
  );

  hash = signal<string>('');

  user = computed<User>(() => ({
    name: this.triviaRain().by,
    avatar: this.triviaRain().avatar,
    steamid: this.triviaRain().steamid ?? '',
    level: this.triviaRain().level ?? 0,
  }));

  async handleChoiceRainTrivia(hash: string) {
    if (this.hash()) {
      this.toastrService.error('You have already chosen an answer');
      return;
    }

    await this.triviaService.choiceAnswerTriviaRain(hash);
    this.hash.set(hash);
    this.toastrService.info('You have chosen an answer');
  }

  async countDownEvent(event: CountdownEvent) {
    if (event.status === CountdownStatus.done) {
      await sleep(1000);
      this.triviaService.rainTrivia.set(null);
    }
  }
}
